import { number, string } from 'prop-types';
import React from 'react';
import classnames from 'classnames';

const getFillId = (pos, rating) =>
  `rating-fraction--${pos}--${String(rating).replace('.', '-')}`;

function calculateStarProps(rating, pos, fillColor) {
  const full = pos <= rating;
  const fill = full ? fillColor : `url(#${getFillId(pos, rating)})`;
  let remainderPercentage = '';
  if (!full) {
    remainderPercentage = pos > rating + 1 ? 0 : (rating + 1 - pos) * 100;
  }
  const starShapeClass = classnames({
    'RecipeRating__star-shape--full': remainderPercentage === '',
    'RecipeRating__star-shape--partial':
      remainderPercentage !== 0 && remainderPercentage !== '',
    'RecipeRating__star-shape--empty': remainderPercentage === 0
  });
  return {
    full,
    fill,
    remainderPercentage,
    starShapeClass
  };
}

function RecipeStar(props) {
  const { rating, pos, fillColor } = props;
  const {
    full,
    fill,
    remainderPercentage,
    starShapeClass
  } = calculateStarProps(rating, pos, fillColor);

  return (
    <svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 128 128" key={pos}>
      {!full && (
        <defs>
          <linearGradient id={getFillId(pos, rating)}>
            <stop offset="0%" stopColor={fillColor} />
            <stop offset={`${remainderPercentage}%`} stopColor={fillColor} />
            <stop offset={`${remainderPercentage}%`} stopColor="#fff" />
            <stop offset="100%" stopColor="#fff" />
          </linearGradient>
        </defs>
      )}

      <polygon
        className={starShapeClass}
        fill={fill}
        stroke={fillColor}
        strokeWidth="4"
        points="128,46.6 85.4,37.7 64,0.1 42.3,37.7 0,46.6 29.1,78.8 24.5,121.9 64,104.2 103.5,121.9 98.9,78.8" // eslint-disable-line
      />
    </svg>
  );
}

RecipeStar.propTypes = {
  rating: number,
  pos: number,
  fillColor: string
};

RecipeStar.defaultProps = {
  rating: 0,
  pos: 0,
  fillColor: '#ffcd3a'
};

export default RecipeStar;
